import { getAuthCookie } from '@/lib/utils/shared/cookies/getAuthCookie'
import useGlobalStore from '@/store/useGlobalStore'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { removeAuthCookie } from '@/lib/utils/shared/cookies/removeAuthCookie'
import { log, logError } from '@/lib/utils/shared/log'
import { useSignInUser } from '../services/useSignInUser'

export const useReAuthenticateUser = () => {
  const {
    setApp,
    user: { isSignedIn, token },
  } = useGlobalStore()

  const { signInWithToken } = useSignInUser({
    isSignInAfterAccountCreation: false,
  })
  const router = useRouter()

  useEffect(() => {
    ;(async () => {
      try {
        if (isSignedIn) return

        log('token', token)

        const authCookie = getAuthCookie()

        if (!authCookie) return

        if (router.pathname.includes('session-expired')) {
          removeAuthCookie({})
          return
        }

        setApp({
          isLoading: true,
        })

        await signInWithToken({
          token: authCookie,
          keepSignedIn: true,
          registered: true,
        })

        setApp({
          isLoading: false,
        })
      } catch (error) {
        logError('Error during re-authentication:', error)
        setApp({
          isLoading: false,
        })
        removeAuthCookie({})
      }
    })()
  }, [isSignedIn])
}
